import DinamicCrudCustomForm from './components/DinamicCrudCustomForm'
import DinamicCrudCustomConsulta from './components/DinamicCrudCustomConsulta'
import { DinamicComponents } from 'scorpion-core'
export function getConfigsDinamic(state) {
    const { DinamicCustomFormsReducer } = state

    if (!DinamicCustomFormsReducer) {
        return null;
    }

    let lista = DinamicCustomFormsReducer.rLista.lista;

    if (lista) {
        return criaConfigCustomForms(lista)
    } else {
        return null;
    }
}

function criaConfigCustomForms(forms) {
    let subConfig = []
    if (forms) {

        forms.forEach((form, index) => {
            if (form.nomeForm) {
                if (form.menu && form.menu.nome) {
                    if (form.consultaPrimeiro) {
                        let r = {
                            route: {
                                path: '/' + form.rota,
                                exact: true,
                                component: DinamicCrudCustomForm,
                                props: { customFormUid: form.uid }
                            },

                        }
                        if (form.permissao) {
                            r.route.permissao = form.permissao
                        }
                        subConfig.push(r)

                        subConfig.push(geraRotaMenu(form.uid, form.rota + "Consulta", form.permissao, form.menu.nome, form.menu.ordem, form.menu.subDe, DinamicCrudCustomConsulta))
                    } else {
                        let config = geraRotaMenu(form.uid, form.rota, form.permissao, form.menu.nome, form.menu.ordem, form.menu.subDe)
                        subConfig.push(config)
                    }
                }
                geraSubConfigs(form, form.componenteRoot.componentes, subConfig)

            }
        })
    }
    return { subConfig }

}


function geraSubConfigs(form, components, subConfig) {
    components.forEach(c => {
        let comp = DinamicComponents.getDinamicComponente(c.typeComponente)
        if (comp && comp.geraSubConfig) {
            let gerador = comp.geraSubConfig(form, c)
            if (gerador) {
                let config = geraRotaMenu(form.uid, form.rota + "/" + gerador.rota, gerador.permissao ? gerador.permissao : form.permissao, gerador.nomeMenu, gerador.ordemMenu, gerador.subDe ? gerador.subDe : form.menu ? form.menu.subDe : "", gerador.component, gerador.propsAdd)
                subConfig.push(config)
            }
        }

        if (c.componentes) {
            geraSubConfigs(form, c.componentes, subConfig)
        }
    })
}


export function getPermissoesDinamic(state) {
    const { DinamicCustomFormsReducer } = state
    if (!DinamicCustomFormsReducer) {
        return null;
    }

    let lista = DinamicCustomFormsReducer.rLista.lista;
    if (lista) {
        return criaListaPermissoes(lista)
    } else {
        return null;
    }
}
function criaListaPermissoes(forms) {
    let listaPermissoes = []
    if (forms) {

        forms.forEach((form, index) => {
            if (form.permissao) {
                listaPermissoes.push(form.permissao)
            }
        })
    }
    return listaPermissoes
}


function geraRotaMenu(uidCustomForm, rota, permissao, nomeMenu, ordemMenu, subDe, component, addProps) {
    let propsSet = { customFormUid: uidCustomForm }
    if (addProps) {
        propsSet = { customFormUid: uidCustomForm, ...addProps }
    }
    let r = {
        route: {
            path: '/' + rota,
            exact: true,
            component: component ? component : DinamicCrudCustomForm,
            props: propsSet
        },

    }

    if (permissao) {
        r.route.permissao = permissao
    }
    if (nomeMenu) {
        let menu = { nome: nomeMenu, rota: '/' + rota, ordem: ordemMenu, subDe: subDe }

        if (permissao) {
            menu.permissao = permissao
        }
        r.menu = menu;
    }
    return r
}


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/functions.js